"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useAvatarGroupPopoverContextValues", {
    enumerable: true,
    get: ()=>useAvatarGroupPopoverContextValues
});
const useAvatarGroupPopoverContextValues = (state)=>{
    const avatarGroup = {
        isOverflow: true,
        size: 24
    };
    return {
        avatarGroup
    };
}; //# sourceMappingURL=useAvatarGroupPopoverContextValues.js.map

//# sourceMappingURL=useAvatarGroupPopoverContextValues.js.map